import { Lock, Crown } from 'lucide-react'

interface TestLockedBadgeProps {
  className?: string
  showLabel?: boolean
}

/**
 * Badge component to indicate a test is locked for free users
 * Can be used as an overlay on test cards or inline badge
 */
export default function TestLockedBadge({
  className = '',
  showLabel = true,
}: TestLockedBadgeProps) {
  return (
    <div
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 bg-amber-100 text-amber-800 rounded-full text-xs font-medium ${className}`}
    >
      <Crown className="w-3.5 h-3.5" />
      {showLabel && <span>Premium</span>}
    </div>
  )
}

interface TestLockedOverlayProps {
  onClick?: () => void
}

/**
 * Full overlay for locked test cards
 * Shows a lock icon with upgrade prompt
 */
export function TestLockedOverlay({ onClick }: TestLockedOverlayProps) {
  return (
    <div
      onClick={onClick}
      className="absolute inset-0 bg-gray-900/10 backdrop-blur-[1px] flex items-center justify-center cursor-pointer rounded-lg transition-all hover:bg-gray-900/20"
    >
      <div className="bg-white rounded-lg shadow-lg p-4 text-center">
        <div className="w-10 h-10 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-2">
          <Lock className="w-5 h-5 text-amber-600" />
        </div>
        <p className="text-sm font-medium text-gray-900">Premium Test</p>
        <p className="text-xs text-gray-500 mt-1">Upgrade to unlock</p>
      </div>
    </div>
  )
}
